/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DirtyWildGameModuleConfig} from "./DirtyWildGameModuleConfig";

export class DirtyWilds extends SlotGame {

    constructor() {
        super(DirtyWildGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M2",
                    "M4",
                    "L4"
                ],
                [
                    "M1",
                    "M5",
                    "M2"
                ],
                [
                    "M4",
                    "M5",
                    "M4"
                ],
                [
                    "M3",
                    "M1",
                    "M2"
                ],
                [
                    "L3",
                    "M3",
                    "M3"
                ]
            ],
            "evaluatedArea": [
                [
                    "M2",
                    "M4",
                    "L4"
                ],
                [
                    "M1",
                    "M5",
                    "M2"
                ],
                [
                    "M4",
                    "M5",
                    "M4"
                ],
                [
                    "M3",
                    "M1",
                    "M2"
                ],
                [
                    "L3",
                    "M3",
                    "M3"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "totalSpinWinningsMultiplied": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 0.5,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "isStickyRespinTriggeredThisSpin": false,
            "numberOfRespinPlayed": 0,
            "winPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "beforeStopSpinsRemaining": 0,
            "beforeStopMultiplier": 0,
            "afterStopSpinsRemaining": 0,
            "afterStopMultiplier": 0,
            "isRandomFeatureTriggered": false,
            "isRandomSyncFeatureTriggered": false,
            "beforeMultiplierIndex": 0,
            "afterMultiplierIndex": 0,
            "randomFeatureActiveSymbol": "",
            "positionsWildInfo": [],
            "syncReels": [
                false,
                false,
                false,
                false,
                false
            ]
        };
    }
}